import { MethodCommands, MethodHandler, MethodProperties } from '@lentau/analytics/health-metrics/shared';

import { authCodeSendHandler, authCodeTokenGetHandler } from './auth-methods-handlers';
import { MethodPropertiesKey } from '../../shared/consts';

export enum AuthMethods {
  AuthCodeSend = 'authCodeSend',
  AuthCodeTokenGet = 'authCodeTokenGet',
}

export const AUTH_HANDLER_LIST: MethodHandler = {
  [AuthMethods.AuthCodeSend]: authCodeSendHandler,
  [AuthMethods.AuthCodeTokenGet]: authCodeTokenGetHandler,
};

export const AUTH_PROPERTIES_LIST: MethodProperties = new Map([
  [
    AuthMethods.AuthCodeSend,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CL,
      },
    ],
  ],
  [
    AuthMethods.AuthCodeTokenGet,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CL,
      },
    ],
  ],
]);
